import { Navigate } from 'react-router-dom';
import { usePermissions } from '../features/permissions/PermissionsContext';
import { getFirstAllowedSetupPath } from '../features/settings/setupRoutes';
import { appPath } from './paths';

const SetupIndexRedirect: React.FC = () => {
  const { hasPermission } = usePermissions();
  const target = getFirstAllowedSetupPath(hasPermission);

  if (target === null) {
    return <Navigate to={appPath('/unauthorized')} replace />;
  }

  return <Navigate to={target} replace />;
};

export default SetupIndexRedirect;
